export const sumTimeStrings = (colValues: string[]) => {
  let min = colValues?.reduce((acc, val) => {
    const t = val?.split(":");
    return acc + Number.parseInt(t[0]) * 60 + Number.parseInt(t[1]);
  }, 0);

  return (
    String(Math?.floor(min / 60))?.padStart(2, "0") +
    ":" +
    String(Math?.floor(min % 60))?.padStart(2, "0")
  );
};
